import loader from '../moduleLoader.js';

class Header {
    constructor(header) {
        this.header = header;
        this.haveScrolled = false;
    }
    init() {
        window.addEventListener('scroll', this.handleScroll.bind(this)); 
        if(this.getScrollTop() > 100) {
            this.header.classList.add('header--minimized');
        }
    }
    handleScroll(e) {
        if(this.haveScrolled) {            
            if(this.getScrollTop() > 100) {
                this.header.classList.add('header--minimized');
            }
            else {
                this.header.classList.remove('header--minimized');
            }
        }
        this.haveScrolled = true;
    }
    getScrollTop() {
        return window.pageYOffset || (document.documentElement || document.body.parentNode || document.body).scrollTop;
    }
}

loader.add('Header', Header);

export default Header;